var React = require('react');

function IconCrossInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.303.697a.5.5 0 0 1 .058.638l-.058.069-4.597 4.595 4.597 4.597a.5.5 0 0 1-.638.765l-.069-.058L6 6.707l-4.596 4.596a.5.5 0 0 1-.765-.638l.058-.069L5.293 6 .697 1.404a.5.5 0 0 1 .638-.765l.069.058 4.595 4.595L10.596.697a.5.5 0 0 1 .707 0Z","fill":"currentColor","fillRule":"evenodd"}));
}

IconCrossInline.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12"};

module.exports = IconCrossInline;

IconCrossInline.default = IconCrossInline;
